import React from 'react';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
// styles
import {
  BulletedListStyled,
  ColStyled,
  TypographyStyled,
} from '../styles';

const baseIdPrefix = 'sitemap-contact-us';
const baseIdSuffix = 'link';

const bulletedListConfig = [
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-contact-us-${baseIdSuffix}`}
        linkUrl='/contact-us/'
        variant='primaryDeemphasize'>
        Contact Us
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-claims-${baseIdSuffix}`}
        linkUrl='/claims/'
        variant='primaryDeemphasize'>
        Claims
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-forms-${baseIdSuffix}`}
        linkUrl='/forms/'
        variant='primaryDeemphasize'>
        Forms
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-customer-service-faq-${baseIdSuffix}`}
        linkUrl='/faq/'
        variant='primaryDeemphasize'>
        Customer Service FAQs
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-annual-percentage-rate-calculator-${baseIdSuffix}`}
        linkUrl='https://media.nmfn.com/APR_Calc/html/global--forms--apr_calc_pg.html?win_type=formcalcxlarge/'
        variant='primaryDeemphasize'>
        Annual Percentage Rate Calculator
      </Link>
    ),
  },
];

export default () => (
  <ColStyled
    medium={6}
    id='sitemap-for-our-clients-list'>
    <TypographyStyled
      component='h2'
      variant='h3'
      nextElement='typography'>
      For Our Clients
    </TypographyStyled>
    <BulletedListStyled
      bulletedListData={bulletedListConfig}
      bulletType='none'/>
  </ColStyled>

);
